import { createRouter, createWebHistory } from 'vue-router'
import { AUTH_CONFIG } from '@/config'

// Import route modules
import authRoutes from './routes/auth'
import dashboardRoutes from './routes/dashboard'
import courseRoutes from './routes/courses'
import lessonRoutes from './routes/lessons'
import homepageRoutes from './routes/homepage'
import assessmentRoutes from './routes/assessments'
import userRoutes from './routes/users'
import instructorRoutes from './routes/instructors'
import contentRoutes from './routes/content'
import mediaRoutes from './routes/media'
import recommendationRoutes from './routes/recommendations'
import sleepRoutes from './routes/sleep'
import miscRoutes from './routes/misc'

// Combine all routes
const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...courseRoutes,
  ...lessonRoutes,
  ...homepageRoutes,
  ...assessmentRoutes,
  ...userRoutes,
  ...instructorRoutes,
  ...contentRoutes,
  ...mediaRoutes,
  ...recommendationRoutes,
  ...sleepRoutes,
  ...miscRoutes
]

// Create router instance
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  // Check if user is authenticated
  const isAuthenticated = !!localStorage.getItem(AUTH_CONFIG.TOKEN_KEY);
  
  // Update document title
  document.title = to.meta.title ? `${to.meta.title} | Kewaar Admin` : 'Kewaar Admin';
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Redirect to login if trying to access protected route without auth
    next({ 
      name: 'Login', 
      query: { redirect: to.fullPath } 
    });
  } else if (to.name === 'Login' && isAuthenticated) {
    // Redirect to dashboard if already logged in and trying to access login page
    next({ name: 'Dashboard' });
  } else {
    // Otherwise proceed as normal
    next();
  }
})

export default router